"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags/tags"));

var _toast = require("./toast.style");

var _iconButton = _interopRequireDefault(require("../icon-button"));

var _modalManager = _interopRequireDefault(require("../modal/__internal__/modal-manager"));

var _events = _interopRequireDefault(require("../../utils/helpers/events/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let Toast = /*#__PURE__*/function (_React$Component) {
  _inherits(Toast, _React$Component);

  var _super = _createSuper(Toast);

  function Toast(props) {
    var _this;

    _classCallCheck(this, Toast);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "dismissToast", ev => {
      const isTopmost = _modalManager.default.isTopmost(_this.toastRef.current);

      if (_this.props.onDismiss && _events.default.isEscKey(ev) && isTopmost) {
        ev.stopImmediatePropagation();

        _this.props.onDismiss(ev);
      }
    });

    _this.toastRef = /*#__PURE__*/_react.default.createRef();
    _this.timer = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  _createClass(Toast, [{
    key: "componentClasses",
    get:
    /** Classes to be applied to the component. */
    function () {
      return (0, _classnames.default)(this.props.className);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _modalManager.default.addModal(this.toastRef.current);

      document.addEventListener("keyup", this.dismissToast);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _modalManager.default.removeModal(this.toastRef.current);

      document.removeEventListener("keyup", this.dismissToast);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      const {
        timeout,
        open,
        onDismiss
      } = this.props;
      clearTimeout(this.timer.current);

      if (!timeout || !open) {
        return;
      }

      this.timer.current = setTimeout(() => onDismiss(), timeout);
    }
  }, {
    key: "closeIcon",
    value: function closeIcon() {
      const {
        onDismiss
      } = this.props;
      if (!onDismiss) return null;
      return /*#__PURE__*/_react.default.createElement(_iconButton.default, {
        "data-element": "close",
        onAction: onDismiss
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "close"
      }));
    }
    /** Content rendered for the toast. */

  }, {
    key: "toastContent",
    value: function toastContent() {
      if (!this.props.open) return null;
      const {
        isCenter,
        variant,
        id,
        as,
        onDismiss,
        children,
        maxWidth
      } = this.props;
      const toastProps = {
        isCenter,
        variant: variant || as,
        id,
        maxWidth
      };
      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        enter: true,
        classNames: "toast",
        timeout: {
          appear: 1600,
          enter: 1500,
          exit: 500
        }
      }, /*#__PURE__*/_react.default.createElement(_toast.ToastStyle, _extends({
        className: this.componentClasses
      }, (0, _tags.default)(this.props["data-component"] || "toast", this.props), toastProps), /*#__PURE__*/_react.default.createElement(_toast.TypeIcon, {
        variant: toastProps.variant
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: toastProps.variant
      })), /*#__PURE__*/_react.default.createElement(_toast.ToastContentStyle, {
        variant: toastProps.variant,
        isDismiss: onDismiss
      }, children), this.closeIcon()));
    }
  }, {
    key: "render",
    value: function render() {
      const {
        targetPortalId,
        isCenter
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_toast.StyledPortal, {
        id: targetPortalId,
        isCenter: isCenter
      }, /*#__PURE__*/_react.default.createElement(_toast.ToastWrapper, {
        isCenter: isCenter,
        ref: this.toastRef
      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, this.toastContent())));
    }
  }]);

  return Toast;
}(_react.default.Component);

Toast.propTypes = {
  /** Customizes the appearance in the DLS theme */
  variant: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),

  /** Customizes the appearance in a legacy theme through colour (see the 'iconColorSets' for possible values) */
  as: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),

  /** Custom className */
  className: _propTypes.default.string,

  /** Custom id  */
  id: _propTypes.default.string,

  /** Component name */
  "data-component": _propTypes.default.string,

  /** The rendered children of the component. */
  children: _propTypes.default.node,

  /** Determines if the Toast is open. */
  open: _propTypes.default.bool,

  /** Callback for when dismissed. */
  onDismiss: _propTypes.default.func,

  /** Time for Toast to remain on screen */
  timeout: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Centers the Toast on the screen */
  isCenter: _propTypes.default.bool,

  /** Target Portal ID where the Toast will render */
  targetPortalId: _propTypes.default.string,

  /** Maximum toast width */
  maxWidth: _propTypes.default.string
};
Toast.defaultProps = {
  as: "warning",
  onDismiss: null,
  open: true,
  isCenter: true
};
var _default = Toast;
exports.default = _default;